<script setup lang="ts">
import ShellToasts from '~/components/mm/shell/ShellToasts.vue'
import '~/components/mm/lyric-video/lyric-video.css'
const { t } = useI18n()
const route = useRoute()
const editor = computed(() => !!route.params.id)
</script>
<template><div class="mm-root lv-shell"><a class="skip" href="#main">{{ t('mm.shell.skip') }}</a><header v-if="!editor" class="lv-brandbar"><NuxtLink to="/studio" class="lv-logo">MusicMint<span class="lv-logo-dot" /></NuxtLink><span>{{ t('lv.title') }}</span><span class="lv-brand-right"><NuxtLink to="/lyric-video/drafts">{{ t('lv.drafts') }}</NuxtLink></span></header><main id="main" tabindex="-1"><slot /></main><ShellToasts /><UpgradeDialog /></div></template>
